import { Temperatur } from './temperatur';

type WetterTypes = {
  uhrzeit: string;
  datum: string;
  maxTemperatur: Temperatur;
  minTemperatur: Temperatur;
  wettercode: number;
  niederschlagWahrscheinlichkeit: number;
  wetterZustand: string;
};

export class Wetter {
  constructor({
    uhrzeit,
    datum,
    maxTemperatur,
    minTemperatur,
    wettercode,
    niederschlagWahrscheinlichkeit,
    wetterZustand,
  }: WetterTypes) {
    this.uhrzeit = uhrzeit;
    this.datum = datum;
    this.maxTemperatur = maxTemperatur;
    this.minTemperatur = minTemperatur;
    this.wettercode = wettercode;
    this.niederschlagWahrscheinlichkeit = niederschlagWahrscheinlichkeit;
    this.wetterZustand = wetterZustand;
  }
  readonly uhrzeit: string;
  readonly datum: string;
  readonly maxTemperatur: Temperatur;
  readonly minTemperatur: Temperatur;
  readonly wettercode: number;
  readonly niederschlagWahrscheinlichkeit: number;
  readonly wetterZustand: string;
}
